import { useSurveysBySubject } from './useSurveys';

/**
 * Hook for fetching DRAFT surveys for DataManagementTab
 * Filters surveys client-side by DRAFT status
 *
 * @param subjectId - Subject ID for scoping surveys
 * @returns Filtered survey data for DRAFT status
 */
export const useDraftSurveysForDataManagement = (subjectId: string) => {
  const query = useSurveysBySubject(subjectId);

  // Filter for DRAFT status surveys
  // Note: query.data is ApiResponse<SurveyDTO[]>, so query.data.data is the array
  // This matches the pattern used in useSurveysForDataManagement
  const draftSurveys = query.data?.data?.filter((survey) => survey.status === 'DRAFT') || [];

  return {
    ...query,
    data: draftSurveys,
  };
};
